import { IFatigueRuleState } from 'types/fatigueRules.interface'

export const DEFAULT_FATIGUE_RULE_FORM: IFatigueRuleState = {
  name: null,
  maxHoursPerShift: null,
  maxHoursPer7Days: null,
  minRestHours: null,
}
